import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import i18n from "micro-i18n";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { getTextRegEx } from "utils";
import { QuestionType, TextInputLength } from "consts";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/TextQuestion.scss';

const TextQuestion = ({ question, onTextChanged, isDisabled }) => {
  const { id, text, type } = question;
  if (type !== QuestionType.Text) {
    return null;
  }

  const [fieldMinLength, setFieldMinLength] = useState(255);
  const [fieldMaxLength, setFieldMaxLength] = useState(255);
  const [validationRegEx, setValidationRegEx] = useState(null);
  const textName = `csw-q-text-${id}`;

  // componentDidMount
  useEffect(() => {
    //TODO: hardcoded to zip regex for now
    //in the future this validation regex will come from the api for a question
    //FIXME: zip lengths are hardcoded in consts for now, but should be definited by the question from the server
    setFieldValidation(TextInputLength.ZipMin, TextInputLength.ZipMax);
  }, []);

  const setFieldValidation = (inputMinLength, inputMaxLength, allowableCharType = "digit") => {
    const inputRegEx = getTextRegEx(inputMinLength, inputMaxLength, allowableCharType);

    setFieldMinLength(inputMinLength);
    setFieldMaxLength(inputMaxLength);
    setValidationRegEx(inputRegEx);
  };

  const onTextChange = (event) => {
    if (event) {
      const updatedText = event.target.value;
      onTextChanged({ question, text: updatedText, validationRegEx });
    }
  };

  return (
    <fieldset className="csw-fieldset csw-q-text">
      <legend className="sr-only" aria-hidden={true}>
        {text}
      </legend>
      {validationRegEx && (
        <input
          className="csw-text-input outline csw-q-text-input"
          type="text"
          name={textName}
          id={id}
          minLength={fieldMinLength}
          maxLength={fieldMaxLength}
          autoComplete="off"
          placeholder={i18n.t("ZIP_CODE_PLACEHOLDER")}
          onBlur={onTextChange}
          onChange={onTextChange}
          onKeyUp={onTextChange}
          disabled={isDisabled}
        />
      )}
    </fieldset>
  );
};

TextQuestion.propTypes /* remove-proptypes */ = {
  question: PropTypes.object.isRequired,
  onTextChanged: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default connect("submitState", actions)(TextQuestion);
